import { Component } from '@angular/core';

import { DepositService } from '../../../service/deposit.service';
import { DepositRedirectService } from '../../../service/depositRedirect.service';
import { PixStatusProcessComponent } from './pix-status-process/pix-status-process.component';
import { WalletProcessComponent } from './wallet-process/wallet-process.component';

@Component({
    selector: 'app-deposit-process',
    templateUrl: './deposit-process.component.html',
    standalone: true,
    imports: [WalletProcessComponent, PixStatusProcessComponent],
})
export class DepositProcessComponent {
    depositSubmitResponse: any;
    constructor(
        private depositRedirect: DepositRedirectService,
        public depositService: DepositService,
    ) {
        this.depositSubmitResponse = this.depositRedirect.depositSubmitResponse;
    }
}
